( function () {
	'use strict';

	function bindViewMore( root ) {
		root.querySelectorAll( '.license-level .view-more, .view-more' ).forEach( function ( viewMoreBtn ) {
			if ( viewMoreBtn.dataset.reqViewMoreBound === '1' ) {
				return;
			}
			viewMoreBtn.dataset.reqViewMoreBound = '1';

			viewMoreBtn.addEventListener( 'click', function ( event ) {
				event.preventDefault();
				var parent =
					viewMoreBtn.closest( '.license-level' ) || viewMoreBtn.parentElement;
				if ( parent ) {
					parent.classList.toggle( 'collapsed' );
				}
				var label = ( viewMoreBtn.textContent || '' ).trim();
				viewMoreBtn.textContent =
					label === 'View More' ? 'View Less' : 'View More';
			} );
		} );
	}

	function init() {
		var containers = document.querySelectorAll(
			'.is-requirements-block, .requirements-block, .is-requirements-block-card'
		);
		if ( containers.length ) {
			containers.forEach( bindViewMore );
			return;
		}
		// Fallback if outer variation class is missing from markup.
		bindViewMore( document );
	}

	if ( document.readyState === 'loading' ) {
		document.addEventListener( 'DOMContentLoaded', init );
	} else {
		init();
	}
} )();
